const { jQuery: $ } = window;

/**
 * @callback KPFfilter
 * @param {*} val
 * @param {*} ...args
 * @return {*}
 */

/**
 * @callback KPFaction
 * @param {*} val
 * @param {*} ...args
 */

export default class PostFilters {
    /** @member {Logger} **/
    #logger;

    /** @member {Mustache} **/
    #mustache;

    /** @member {jQuery} **/
    #$el = null;

    /** @member {boolean} **/
    #active = false;

    /** @member {boolean} **/
    #loaded = false;

    /** @member {object} **/
    #settings = null;

    /** @member {object} **/
    #hooks = {filters: {}, actions: {}};

    /** @member {jQuery} **/
    #$postfilters;

    /** @member {int[]} **/
    #transitions = [];

    /** @member {boolean} **/
    #locked = false;

    /** @member {jqXHR} **/
    #currentRequest = null;

    /** @member {object[]} **/
    #shortcodes = [];

    /**
     * @param {Logger} logger
     * @param {Mustache} mustache
     */
    constructor(logger, mustache) {
        this.#logger = logger;
        this.#mustache = mustache;

        this.logger.start("Plugin Setup");

        this.#$el = $(".kmdg-post-filters");

        if(this.$el.length > 0) {
            this.#active = true;
            this.logger.log("Shortcode found on page.");
            this.logger.log("KPF Settings:")

            if(typeof KMDGPostFilters !== 'undefined') {
                this.#settings = KMDGPostFilters.settings;
                this.logger.table(this.#settings, ["Value"]);
                this.$el.find(".kpfsc__explore").remove();
                this.$el.removeClass("kpfsc--no-js");

                if(history.state && history.state['kpf-shortcodes']) {
                    this.#shortcodes = history.state['kpf-shortcodes'];

                    this.logger
                        .groupStart("History", "Load State", this.logger.COLOR.PURPLE)
                        .log(this.#shortcodes)
                        .groupEnd();
                }
            } else {
                this.logger.error("Settings object not found! Aborting...");
                this.#active = false;
            }

        } else {
            this.logger.log("Shortcode not found on page.");
        }

        this.logger.log("Status:", (this.#active ? "Active" : "Inactive"));

        this.logger.end();
    }

    /**
     * This function is called as soon as the PostFilters are initialized, before anything else runs. Its entire
     * purpose is to trigger an event on the window called "kpf:ready", which includes the PostFilters
     * object in its event data. Hooking into this event lets you use the actions and filters system built into this
     * plugin.
     */
    ready() {
        KMDGPostFilters.class = this;

        // Delay a tick so that other things registered on window ready can hook in.
        setTimeout(()=> {
            this.logger.log("Broadcast Ready Event (\"kpf:ready\")");
            $(window).trigger("kpf:ready", [this]);
        }, 0);
    }

    /**
     * Boots up the post filter system.
     */
    load() {
        if(!this.#active) return;

        if(this.#loaded) {
            this.logger.error("Plugin already loaded!");
            return;
        }

        const self = this;

        this.logger.log("Loading...");

        this.#loaded = true;

        // Default select2 options
        const select2Opts = this.#applyFilter("select2_options", {
            debug: this.logger.isDebug,
            dropdownAutoWidth: true,
            dropdownCssClass: "kpfsc--" + this.$el.attr("data-template") + "-template",
            selectionCssClass: "kpfsc--" + this.$el.attr("data-template") + "-template",
            minimumResultsForSearch: Infinity,
            allowClear: true
        });

        this.#settings.ajax  = this.#applyFilter("ajax_options", {
            dataType: "json",
            method: "GET",
        });

        // Setup shortcode setting data
        this.$el.each((i, el) => {
            let settings = $(el).data("settings");
            const state = this.#shortcodes[el.id];
            const defaults = structuredClone(settings);

            if(state) {
                this.logger.log("Loading historical posts...");

                settings = state.settings
                const page = settings.filterPage;

                this.data($(el), null, settings);
                this.#transitionPosts($(el), state.cache, state.requiresReload,0, () => {
                    this.data($(el), "filterPage", page); // Reset page number after clear.

                    if(settings.queryMeta.pages <= settings.filterPage) {
                        $(el).addClass("kpfsc--no-more");
                    } else {
                        $(el).removeClass("kpfsc--no-more");
                    }

                    if(state.cache.length === 0) {
                        $(el).addClass("kpfsc--no-posts");
                    } else {
                        $(el).removeClass("kpfsc--no-posts");
                    }
                });
            } else {
                this.#shortcodes[el.id] = {
                    "settings": settings,
                    "cache": []
                };

                this.data($(el), "defaults", defaults);
            }

            this.logger
                .start("Loaded Configuration")
                .groupStart("Select2", "Default Options", this.logger.COLOR.PURPLE)
                .table(select2Opts, ["Value"])
                .groupEnd()
                .groupStart("Filters", "Settings", this.logger.COLOR.PURPLE)
                .log(settings)
                .groupEnd()
                .end();
        });

        // Prevent form submission (handle with ajax)
        this.$el.on("submit", (e) => {
            e.preventDefault();
            return false;
        });

        this.$el.find(".kpfsc__filter select").each((i, el) => {
            const $el = $(el);
            const $parent = $el.parents(".kpfsc"); // current filter parent, in case of multiple shortcodes
            const name = $el.attr("name");
            const config = this.#applyFilter(`select2_options_${name}`, select2Opts, $el, $parent);
            const state = this.#shortcodes[$parent.attr("id")];

            if(config !== false) {
                // Allow each filter to potentially have its own select2 options, also allow disabling select2

                $el.select2(config);

                // Load filter state from history
                if(state && state.settings.filterSelected[name]) {
                    $el.val(state.settings.filterSelected[name]);
                    $el.trigger("change");
                }

                // Filters are loaded with all terms by default, this fetches a more narrow list based on post type
                if($el.is(".kbfsc__filter--taxonomy")) {
                    $(window).on("load", () => {
                        this.#fetch("filters", {
                            'types': this.data($parent, "queryMeta").query.types,
                            'filter': $el.attr("name")
                        }).done((response) => {
                            $el.select2({data: response});
                        });
                    });
                }
            }

            $el.on("change", () => {
                this.data($parent, "filterPage", 1);

                let selected = this.data($parent, "filterSelected");
                selected[name] = $el.val();
                this.data($parent, "filterSelected", selected);

                this.#shortcodes[$parent.attr("id")].cache = [];

                this.#getPosts($parent, this.data($parent, "filterLimit"), (posts, meta) => {
                    this.#transitionPosts($parent, posts, true);
                });
            });
        });

        // Operate clear button on filters
        this.$el.find(".kpfsc__clear").on("click", function () {
            const $parent = $(this).parents(".kpfsc");
            const defaults = self.data($parent, "defaults");

            self.logger.log("Clearing form...");

            $parent.get(0).reset();
            $parent.find(".kpfsc__search-bar").val("");

            self.#shortcodes[$parent.attr('id')].cache = [];
            self.#shortcodes[$parent.attr('id')].requiresReload = false;
            self.data($parent, null, structuredClone(defaults));
            self.data($parent, "defaults", defaults); // Reset defaults since above null property wipes them
            self.data($parent, "searchQuery", "");

            self.#saveState();

            $parent.find(".kpfsc__filter").not(".kpfsc--hidden").find("select").val(null).trigger("change");
        });

        // Monitor search bar for changes
        this.$el.find(".kpfsc__search-bar").on("keyup change", this.#debounce(250, false, function() {
            const $this = $(this);
            const $parent = $this.parents(".kpfsc");

            self.logger.log("Searching posts...");
            self.data($parent, "searchQuery", $this.val());

            self.#shortcodes[$parent.attr("id")].cache = [];

            self.#getPosts($parent, self.data($parent, "filterLimit"), (posts, meta) => {
                self.#transitionPosts($parent, posts, true);
            });
        }));

        // Watch for clicks on load more button
        this.$el.find(".kpfsc__load-more").on("click", function(e) {
            e.preventDefault();
            const $this = $(this);
            const $parent = $this.parents(".kpfsc");
            const page = self.data($parent, "filterPage") + 1;

            self.logger.log("Loading More Posts...");

            self.data($parent, "filterPage", page);

            self.#getPosts($parent, self.data($parent, "filterMore"), (posts, meta) => {
                self.#transitionPosts($parent, posts);
            });

            return false;
        });

        this.#doAction("plugin_loaded");
    }

    /**
     * Registers a filter that will run at the specified hook name, with a given priority. Filters can return a new
     * value, replacing or modifying the default provided by the core code. This works identically to the WordPress
     * add_filter() function in php.
     *
     * @param {string} name The name of the filter you want to hook into.
     * @param {KPFfilter} callback The function to be called when the filter is triggered.
     * @param {int} priority The priority of the filter, when multiple filters are registered the lower number will run
     * first, and each subsequent filter will receive the value returned by the previous one.
     */
    addFilter(name, callback, priority = 10) {
        this.#addHook("filters", name, callback, priority);
    }

    /**
     * Registers an action that will run at the specified hook name, with a given priority. This works identically to
     * WordPress' add_action() in php.
     *
     * @param {string} name The name of the action you want to hook into.
     * @param {KPFaction} callback The function to be called when the action is triggered.
     * @param {int} priority The priority of the action, when multiple actions are registered lower numbers will run first.
     */
    addAction(name, callback, priority = 10) {
        this.#addHook("actions", name, callback, priority);
    }

    /**
     * Registers a user created external hook to be run later via runHook.
     *
     * @param {string} type
     * @param {string} name
     * @param {function} callback
     * @param {int} priority
     */
    #addHook(type, name, callback, priority = 10) {
        this.#hooks[type][name] = this.#hooks[type][name] || {};
        this.#hooks[type][name][priority] = this.#hooks[type][name][priority] || [];
        this.#hooks[type][name][priority].push(callback);
    }

    /**
     * Wrapper for runHook that specifies a filter type hook.
     * @param {string} name
     * @param {*} val
     * @param {*} args
     * @returns {*}
     */
    #applyFilter(name, val, ...args) {
        return this.#runHook("filters", name, val, ...args);
    }

    /**
     * Wrapper for runHook that specifies an action type hook.
     *
     * @param {string} name
     * @param {*} args
     */
    #doAction(name, ...args) {
        this.#runHook("actions", name, null, ...args);
    }

    /**
     * Loops through all callbacks hooked into a given hook and runs them in priority order.
     *
     * @param {string} type "action" or "filter"
     * @param {string} name The name of the hook.
     * @param {*} val The initial value of the filter (for filters only).
     * @param {*} args The additional arguments being passed into the hook.
     * @returns {*} The value of the filter or void for actions.
     */
    #runHook(type, name, val, ...args) {
        const hooks = this.#hooks[type][name] || false;
        let ret = val;

        if(hooks && Object.keys(hooks).length > 0) {
            const label = (type === "actions") ? "Action" : "Filter";

            this.logger.timerStart("Run Time");
            let counter = 0;
            let errors = 0;

            this.logger
                .start(`${label}: ${name}`)
                .groupStart("Arguments", "", this.logger.COLOR.PURPLE)
                .table(args, ["Value"])
                .groupEnd()
                .groupStart(`${label}s`, "", this.logger.COLOR.PURPLE);

            for(let priority in hooks) {
                this.logger.groupStart("Priority", priority, this.logger.COLOR.GREEN);

                for(let i in hooks[priority]) {
                    counter++;
                    this.logger
                        .groupStart(label, "", this.logger.COLOR.TURQUOISE)
                        .timerStart(`${label} Run Time`)
                        .groupStart("Console", "", this.logger.COLOR.CYAN);

                    try {
                        if(type === "actions") {
                            hooks[priority][i].apply(this, args);
                        } else {
                            ret = hooks[priority][i].call(this, ret, ...args);
                        }
                    } catch(e) {
                        errors++;
                        this.logger.error(e);
                    }

                    this.logger
                        .groupEnd()
                        .timerEnd(`${label} Run Time`)
                        .dir(hooks[priority][i])
                        .groupEnd();
                }

                this.logger.groupEnd();
            }

            this.logger
                .groupEnd()
                .groupStart("Stats", "", this.logger.COLOR.PURPLE)
                .log(`${label} Count:`, counter)
                .log("Error Count:", errors);

            if(type === 'filters') {
                this.logger.log("Final Value:", ret);
            }

            this.logger
                .timerEnd("Run Time")
                .groupEnd()
                .end();
        } else {
            this.#hooks[type][name] = {};
        }

        return ret;
    }

    /**
     * Provides a standardized wrapper around jQuery.ajax(), with built-in support for before and after action hooks.
     * There are two hooks for both before and after, one generic and one specific to the endpoint that is being called.
     *
     * @param {string} endpoint The REST API endpoint to be called
     * @param {object} data The data to be sent to the server via query string.
     * @returns {jQuery.Deferred}
     */
    #fetch(endpoint, data = {}) {
        const $ajaxOpts = $.extend({
            data: data,
            method: "GET",
            beforeSend: (jqXHR) => {
                this.#doAction(`ajax_loading_${endpoint}`, jqXHR, data);
                this.#doAction("ajax_loading", endpoint, jqXHR, data);
                this.#currentRequest = jqXHR;
            }
        }, this.#settings.ajax);

        const settings = this.#applyFilter(`ajax_settings_${endpoint}`, $ajaxOpts, data);

        return $.ajax(`${this.settings.restBase}/${endpoint}`, settings)
            .always((response) => {
                this.#currentRequest = null;
                this.#doAction(`ajax_finished_${endpoint}`, response, data)
                this.#doAction("ajax_finished", endpoint, response, data)
            });
    }

    /**
     * Retrieves posts from the server. Filter post_request_data to change the request, and get_posts_response to change
     * the response from the server before it is processed.
     *
     * @param {jQuery} $el The shortcode element the settings for this request will be drawn from.
     * @param {int} count The number of posts to try to retrieve (might be different between filter changes and load more events)
     * @param {Function} callback This will be called when a response is returned from the server.
     */
    #getPosts($el, count, callback) {
        if(this.#currentRequest) {
            this.#currentRequest.abort();
        }

        const settings = this.data($el);

        this.#fetch("posts", {
            "request": JSON.stringify(this.#applyFilter("post_request_settings", settings)),
            "count": count
        }).done((response) => {
            this.logger.start("Get Posts")
                .groupStart("Request", "Data", this.logger.COLOR.PURPLE)
                .dir(settings)
                .groupEnd()
                .groupStart("Response", "Metadata", this.logger.COLOR.PURPLE)
                .table(response.meta)
                .groupEnd()
                .groupStart("Response", "Posts", this.logger.COLOR.PURPLE)
                .dir(response.posts)
                .groupEnd()
                .end();

            response = this.#applyFilter("get_posts_response", response, settings, $el);

            this.data($el, "queryMeta", response.meta);

            if(response.meta.pages <= this.data($el, "filterPage")) {
                $el.addClass("kpfsc--no-more");
            } else {
                $el.removeClass("kpfsc--no-more");
            }

            if(response.posts.length === 0) {
                $el.addClass("kpfsc--no-posts");
            } else {
                $el.removeClass("kpfsc--no-posts");
            }

            // History state management
            const state = this.#shortcodes[$el.attr('id')];
            const selected = this.data($el, "filterSelected");
            const defaults = this.data($el, "defaults");

            state.cache.push(...response.posts);
            state.requiresReload = false;

            // Check if any filters are selected, require reload if these are not the same as any default filters
            for(let i in selected) {
                // Make sure all filter values are arrays to account for multiple selections
                const defaultSelected = Array.isArray(defaults.filterSelected[i]) ? defaults.filterSelected[i] : [defaults.filterSelected[i]];
                const activeSelected = Array.isArray(selected[i]) ? selected[i] : [selected[i]];

                // Find common values
                const filtersWithDefaultVals = defaultSelected.filter(x => activeSelected.includes(x));

                // Check if they match (not matching indicates current selections differ from defaults)
                if(filtersWithDefaultVals.length !== activeSelected.length) {
                    state.requiresReload = true;
                    break;
                }
            }

            this.#saveState();

            callback.call(this, response.posts, response.meta);

            this.#doAction("get_posts_success", response, settings, $el);

        }).fail((jqXHR, textStatus, errorThrown) => {

            if(textStatus === "abort") {
                this.logger.warn("Get Posts: Aborted");
                this.#doAction("get_posts_aborted", jqXHR, textStatus, errorThrown, settings, $el);
            } else {
                this.logger.start("Get Posts")
                    .log("jqXHR:", jqXHR)
                    .log("textStatus:", textStatus)
                    .error("Error:", errorThrown)
                    .end();

                this.#doAction("get_posts_failed", jqXHR, textStatus, errorThrown, settings, $el);
            }

        });
    }

    /**
     * This renders an individual post using the Mustache template. You can filter the post_template to change the
     * template on a per-post basis. You can also filter post_data to change the data being passed into the template, or
     * render_post_output to filter the end result.
     *
     * @param {jQuery} $el The shortcode element the posts will be rendered in.
     * @param {object} post The post object to be rendered.
     * @returns {string} Returns the rendered HTML for the post.
     */
    #renderPost($el, post) {
        const template = this.#applyFilter("post_template", $el.find(".kpfsc__template").text(), $el, post);

        let output = this.#mustache.render(template, this.#applyFilter("post_data", post, $el));

        return this.#applyFilter("render_post_output", output, $el, post);
    }

    /**
     * This function transitions in posts, adding them to the DOM with an increasing delay to stagger their entry. This
     * allows them to be animated in with CSS transition effects. You can filter post_transition_speed to adjust this
     * effect, a setting of 0 will disable the effect.
     *
     * @param {jQuery} $el The shortcode element the posts will be rendered in.
     * @param {array} posts The array of posts to be rendered.
     * @param {boolean} clear If the post area should be cleared before adding in the new posts.
     * @param {int} delay The number of milliseconds to wait between adding a post to the DOM
     * @param {Function} done This is called when posts finish transitioning
     */
    #transitionPosts($el, posts, clear = false, delay = 150, done = null) {
        const $posts = $el.find(".kpfsc__posts");
        let counter = 0;
        let remaining = posts.length;
        delay = this.#applyFilter("post_transition_delay", delay, $el);

        if(clear) {
            // Remove all running transitions
            for(let i in this.#transitions) {
                clearTimeout(this.#transitions.pop());
            }

            this.data($el, "filterPage", 1);
            $posts.html("");
        }

        if(!done) {
            done = ($el) => {this.logger.log("Finished Transitioning Posts.")};
        }

        // Reset transitions
        this.#transitions = [];

        for(let i in posts) {
            // Set timeout for transitions and store it, so we can cancel them if needed.
            this.#transitions.push(setTimeout(() => {
                $posts.append(this.#renderPost($el, posts[i]));
                remaining--;

                if(remaining === 0) {
                    done($el);
                    this.#doAction("posts_transition_finished", $el);
                }
            }, counter * delay));
            counter++;
        }
    }

    /**
     * Wrapper getter and setter for shortcode settings data.
     *
     * TODO: I think we can move away from using both this.#shortcodes and $shortcode.data() with a bit of refactoring.
     *
     * @param $shortcode
     * @param property
     * @param value
     * @returns {*}
     */
    data($shortcode, property = null, value = null) {
        const settings = $shortcode.data("settings");

        if(value === null) {
            if(property === null) {
                return settings;
            } else {
                return settings[property];
            }
        } else {
            if(property === null) {
                this.#shortcodes[$shortcode.attr("id")].settings = value;
                $shortcode.data("settings", value);
            } else {
                settings[property] = value;
                this.#shortcodes[$shortcode.attr("id")].settings = settings;
                $shortcode.data("settings", settings);
            }
        }
    }

    /**
     * This function will self-throttle so that the callback is only called once every X milliseconds. Use the immediate flag
     * to let the first run of this to call the callback immediately, else it will wait for the timeout before calling it
     * for the first time.
     *
     * Note: This returns a function, so it can be used directly when creating an event watcher.
     *
     * @param {number} wait
     * @param {boolean} immediate
     * @param {callback} func
     * @returns {callback}
     */
    #debounce(wait, immediate, func) {
        let timeout;
        return function () {
            let context = this, args = arguments;
            let later = function () {
                timeout = null;
                func.apply(context, args);
            };
            let callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    /**
     * Saves the shortcode states in browser history,
     */
    #saveState() {
        try {
            history.replaceState({
                "kpf-shortcodes": this.#shortcodes,
            }, "");
        } catch (e) {
            this.logger.warn("Failed to save history.");
        }
    }

    /**
     * Getter for the shortcode elements on the page.
     * @returns {jQuery}
     */
    get $el() {
        return this.#$el;
    }

    /**
     * Getter for the settings object used by the plugin.
     * @returns {Object}
     */
    get settings() {
        return structuredClone(this.#settings);
    }

    /**
     * Getter for the logger class.
     * @returns {Logger}
     */
    get logger() {
        return this.#logger;
    }

    /**
     * Prints a list of all actions and filters available for this class.
     */
    printHooks() {
        this.logger
            .start("Actions & Filters")
            .groupStart("Actions", "", this.logger.COLOR.PURPLE)
            .dir(this.#hooks.actions)
            .groupEnd()
            .groupStart("Filters", "", this.logger.COLOR.PURPLE)
            .dir(this.#hooks.filters)
            .groupEnd()
            .end()
    }
}